import { Home, Generate, History } from './views'

export const routesConfig = (appName, displayName) => ([
  { path: `/${appName}/generate`, element: Generate, breadcrumb: 'Generera runda' },
  { path: `/${appName}/history`,  element: History,  breadcrumb: 'Historik' },
  { path: `/${appName}/`,         element: Home,      breadcrumb: displayName },
])
